import { normalizeToE164 } from "./phoneUtils";

/** Fields allowed on PUT/PATCH employee/updateEmployeeById/:id (HRMS profile). */
export const HRMS_UPDATABLE_KEYS = new Set([
  "first_name",
  "last_name",
  "email",
  "phone",
  "role_id",
  "manager_id",
  "status",
  "doj",
  "designation",
  "branch_office",
  "department",
  "location",
  "employment_type",
  "date_of_birth",
  "gender",
  "nationality",
  "marital_status",
  "blood_group",
  "personal_phone",
  "personal_email",
  "emergency_contact_name",
  "emergency_contact_number",
  "present_address",
  "permanent_address",
  "address_1",
  "address_2",
  "country_id",
  "state_id",
  "city_id",
  "zipcode",
  "uan",
  "pan",
  "aadhaar",
  "meeting_link",
]);

export function normalizeGenderHrms(value) {
  if (value === null || value === undefined || value === "") return "";
  const g = String(value).trim().toLowerCase();
  if (g === "male" || g === "m") return "male";
  if (g === "female" || g === "f") return "female";
  return g;
}

export function normalizeDateString(value) {
  if (!value) return "";
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function scalarForCompare(key, value) {
  if (value === null || value === undefined) return "";
  if (key === "gender") return normalizeGenderHrms(value);
  if (key === "doj" || key === "date_of_birth") {
    return normalizeDateString(value);
  }
  if (key === "status") {
    return String(Number(value) === 1 || value === true ? 1 : 0);
  }
  if (key === "phone" || key === "personal_phone") {
    const normalized = normalizeToE164(value);
    return normalized || String(value).trim();
  }
  return String(value);
}

function normalizeOutboundValue(key, value) {
  let outVal = value;
  if (key === "gender") {
    outVal = normalizeGenderHrms(value);
  } else if (key === "doj" || key === "date_of_birth") {
    outVal = normalizeDateString(value) || null;
  } else if (key === "phone" || key === "personal_phone") {
    const normalized = normalizeToE164(value);
    outVal = normalized || (value === "" ? "" : value);
  }
  return outVal === undefined ? "" : outVal;
}

/**
 * Build a partial update body containing only fields that changed vs baseline.
 */
export function buildEmployeePartialPayload(
  edited,
  baseline,
  allowedKeys = HRMS_UPDATABLE_KEYS,
) {
  const partial = {};
  const base = baseline || {};
  allowedKeys.forEach((key) => {
    const hasEdited = Object.prototype.hasOwnProperty.call(edited, key);
    const current = hasEdited ? edited[key] : base[key];
    const baseVal = base[key];
    if (scalarForCompare(key, current) !== scalarForCompare(key, baseVal)) {
      const outVal = normalizeOutboundValue(key, current);
      partial[key] = outVal === "" ? "" : outVal;
    }
  });
  return partial;
}

export function resolveEmployeeUuid(edited, contextRow) {
  return String(
    edited?.employee_id ||
      edited?.employeeID ||
      contextRow?.employee_id ||
      contextRow?.employeeID ||
      "",
  ).trim();
}

/** Admin Employees page form — partial body on update only. */
export function buildEmployeeAdminFormPartialPayload(fieldConfiguration, baseline) {
  const partial = {};
  const base = baseline || {};
  Object.keys(fieldConfiguration || {}).forEach((key) => {
    if (key === "password") return;
    const current = fieldConfiguration[key]?.value;
    const baseVal = base[key];
    if (scalarForCompare(key, current) === scalarForCompare(key, baseVal)) {
      return;
    }
    const outVal = normalizeOutboundValue(key, current);
    partial[key] = outVal === "" ? "" : outVal;
  });
  return partial;
}
